import { render, staticRenderFns } from "./CreateUserGroupModal.vue?vue&type=template&id=4d6d8a83&scoped=true"
import script from "./CreateUserGroupModal.vue?vue&type=script&lang=js"
export * from "./CreateUserGroupModal.vue?vue&type=script&lang=js"
import style0 from "./CreateUserGroupModal.vue?vue&type=style&index=0&id=4d6d8a83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6d8a83",
  null
  
)

export default component.exports